import * as React from 'react'
import { Redirect } from 'react-router'
import { ITripStatus, IStateUser, IActiveTripResponseV2, IPickupNote, ITripEdit } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import Modal from '../../../ui/Modal'

export interface IDriverPnoteModalProps {
  currentTripId: string
  startMileage: string
  history: any
  match: any
  saveNote: (params: IPickupNote) => Promise<any>
  saveData: (params: ITripEdit) => Promise<any>
}

interface IDriverPnoteModalState {
  isSubmitting: boolean
  error: string
  isModalOpen: boolean
  pickUpNote: string
  redirect: boolean
}

class DriverPnoteModal extends React.Component<IDriverPnoteModalProps, IDriverPnoteModalState> {
  constructor(props: IDriverPnoteModalProps) {
    super(props)

    this.state = {
      isSubmitting: false,
      error: '',
      isModalOpen: false,
      pickUpNote: '',
      redirect: false
    }
  }

  public render() {
    const { currentTripId, startMileage } = this.props
    //TODO: Editing of Notes
    const saveText = this.state.isSubmitting ? 'Saving...' : UIMessages.common.addNote
    if (this.state.redirect === true) {
      return <Redirect to={`/trips/${this.props.currentTripId}`} />
    }
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-3 p2'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase'>
              {UIMessages.common.PickupNote}
              {/* <div className='ModalAddTitle font-small weight-300 font-grey2 ml2 mr2 uppercase' style={{color: 'red', fontSize: '15'}}>{currentTripId}</div> */}
            </span>

            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='ml2 mr2 mt1'
            >
              <div className='mb1 mt1'>
                <span className='font-grey3 h5'>{UIMessages.common.Note}</span>
                <input
                  type='Text'
                  name='pNote'
                  defaultValue={startMileage}
                  className='form-control'
                  onChange={this.onChange}
                />
              </div>
            </div>
            <div className='flex items-center justify-end mt3'>
              <button
                type='button'
                onClick={this.handleCancelClick}
                disabled={this.state.isSubmitting}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='button'
                onClick={() => {
                  this.savePickUpNote()
                }}
                disabled={this.state.isSubmitting}
                className='SubmitButton btn bg-green rounded font-white weight-300'
              >
                {saveText}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.history.push(`${this.props.history.goBack()}`)
    this.setState({ isModalOpen: false })
  }
  private onChange = (e: any) => {
    this.setState({
      pickUpNote: `${e.target.value}`
    })
  }
  private async savePickUpNote() {
    const params: IPickupNote = {
      prevStartMileage: this.props.startMileage ? this.props.startMileage : ' ',
      startMileage: this.state.pickUpNote,
      pickUpFlag: 1
    }
    await this.props.saveNote(params)
    this.setState({
      redirect: true
    })

    /*   //Audit Trail
     const params1: ITripEdit = {
      notes: this.state.pickUpNote,
      prevNotes: this.props.startMileage
    }
    await this.props.saveData(params1)
 */
  }
}

export default DriverPnoteModal



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/note-modal/DriverPnoteModal.tsx